module.exports = __webpack_public_path__ + "static/media/share_icon.5379277a.svg";